<template>
  <transition name="slide-right">
    <!-- <cube-popup
      v-show="isVisible"
      type="my-popup"
      :center="false"
      position="right"
      class="filter-wrap"
      @mask-click="maskClick"
    > -->
    <div
      v-if="visible"
      class="filter-wrap"
    >
      <div
        v-if="!loading"
        ref="bscroll"
        class="scroll-wrap"
      >
        <!-- <cube-scroll ref="filterScroll"> -->
        <cube-form
          class="filter-form"
          :options="{layout: 'classic'}"
        >
          <div class="filter-item code">
            <p class="filter-tit">
              {{ $t('message["35"]') }}
            </p>
            <cube-input
              v-model="form.code.value"
              :placeholder="form.code.placeholder"
              :clearable="form.code.clearable"
            />
          </div>
          <filter-item
            v-for="(item) in newFormData"
            :ref="`filteritem_${item.fieldkey}`"
            :key="item.fileldkey"
            class="clearfix"
            :data="item"
            :filter="filterResult"
            @change="onChangeItem"
          />
        </cube-form>

        <!-- </cube-scroll> -->
        <div class="footer">
          <cube-button
            class="reset-btn"
            @click="reset"
          >
            {{ $t('message["736"]') }}
          </cube-button>
          <cube-button
            class="confirm-btn cube-btn-primary"
            @click="submitHandle"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </div>
      </div>
    </div>
    <!-- </cube-popup> -->
  </transition>
</template>

<script>
import FilterItem from './FilterItem'
import { mapState, mapActions } from 'vuex'
import { jsonToBase64 } from '@/lib/utils'
import BScroll from 'better-scroll'
// import eventBus from '@/lib/eventBus'

export default {
  components: {
    FilterItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    paramsType: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      // isVisible: false,
      form: {
        code: {
          value: '',
          clearable: {
            visible: true,
            blurHidden: true
          },
          placeholder: this.$t('message["1122"]')
        }
      }
    }
  },
  computed: {
    ...mapState('inquery/filterData', ['filterFormData', 'loading', 'filterResult', 'filterStr']),

    newFormData () {
      for (let item of this.filterFormData) {
        const { fieldkey, fieldtype } = item
        for (let key in this.filterResult) {
          if (fieldkey === key) {
            if (item.isneeded === 1) {
              item.isneeded = 0
            }

            let value
            if (fieldtype === 'radioinfo_type' && item.fieldconfig && item.fieldconfig.info_sign) {
              let { fieldvalue = [], info_sign: infosignValue = [] } = this.filterResult[key] || {}
              value = fieldvalue
              this.$set(item.fieldconfig.info_sign, 'fieldvalue', infosignValue)
            } else {
              value = this.filterResult[key] && this.filterResult[key].fieldvalue
            }
            this.$set(item, 'fieldvalue', value)
          }
        }
        if (!Object.keys(this.filterResult).length) {
          for (let item of this.filterFormData) {
            item.fieldvalue = ''
          }
        }
      }
      return this.filterFormData
    },
    /* defaultFilter () {
      const { filter } = this.$route.query
      if (filter) {
        return base64ToJson(filter)
      }
      return {}
    }, */
    query () {
      return this.$route.query
    }
  },
  watch: {
    async visible (val) {
      // this.isVisible = val
      if (val) {
        await this.getQuery()
      }
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions('inquery/filterData', ['fetchQuery', 'setFilterResult', 'setFilterStr']),
    async getQuery () {
      let _this = this
      const chain = await this.fetchQuery()
      const { from = '', paramsType = '' } = this
      chain
        .params({
          scope: from,
          type: paramsType
        })
        .onSuccess(res => {
          if (_this.visible && res && res.config && res.config.length) {
            _this.$nextTick(() => {
              _this.setScroll()
            })
          }
        })
        .fetch()
    },
    setScroll () {
      // if (!this.scroll) {
      this.scroll = new BScroll(this.$refs.bscroll, {
        click: true
      })
      // } else {
      //   this.scroll.refresh()
      // }
    },
    onChangeItem () {

    },
    hide () {
      this.$emit('update:visible', false)
      this.setFilterResult({})
    },
    maskClick () {
      this.hide()
    },
    reset () {
      let { from = '', type = '', code = '' } = this.$route.query

      this.$router.push({
        name: 'InqueryList',
        query: {
          from,
          type,
          code,
          _t: new Date().getTime(),
          page: 1,
          limit: 10
        }
      })

      this.setFilterStr('')
      this.setFilterResult({})
      this.form.code.value = ''
      // eventBus.$emit('fetchInquiryList')
      this.hide()
    },

    async submitHandle (e) {
      // console.log(this.$refs)
      const keys = Object.keys(this.$refs).filter(key => key.indexOf('filteritem_') === 0)
      const { length } = keys
      let hasError = false
      this.errorElements = []
      for (let i = 0; i < length; i++) {
        const id = keys[i]
        const ref = this.$refs[id][0]
        if (ref && ref.validate) {
          ref.validate((result) => {
            // TODO: 异步校验
            console.log(ref.data)
            if (result === false) {
              hasError = true
            }
          })
        }
      }
      if (!hasError) {
        this.handleSubmit()
      }
    },
    async  handleSubmit () {
      this.hide()
      /* const { newFormData } = this
      const maps = this.defaultFilter
      newFormData.forEach(item => {
        const { fieldkey, value } = item
        if (typeof value !== 'undefined') {
          maps[fieldkey] = value
        }
      })
      console.log(maps)
      console.log(jsonToBase64(maps)) */
      const urlFilters = await this.setFilterUrlData()
      // 存 store
      this.setFilterResult(urlFilters)
      this.$router.push({
        name: 'InqueryList',
        query: {
          ...this.query,
          // filter: jsonToBase64(maps),
          // filter: jsonToBase64(urlFilters),
          _t: new Date().getTime(),
          page: 1,
          limit: 10
        }
      })
      this.setFilterStr(jsonToBase64(urlFilters))
      // eventBus.$emit('fetchInquiryList')
      // location.reload()
    },
    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    async setFilterUrlData (type) {
      let obj = {}
      for (let item of this.filterFormData) {
        let one = {}
        one.fieldtype = item.fieldtype
        one.fieldkey = item.fieldtype
        one.fieldvalue = item.fieldvalue
        if (item.fieldtype === 'radioinfo_type') {
          const { fieldconfig = {} } = item || {}
          const { info_sign: infoSign = {} } = fieldconfig
          one.info_sign = infoSign.fieldvalue
        }
        obj[item.fieldkey] = one
      }
      obj.code = {}
      obj.code.fieldtype = 'code'
      obj.code.fieldkey = 'code'
      obj.code.fieldvalue = this.form.code.value
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  // overflow-x: hidden;
  .filter-form {
    padding: 12px 0 70px;
    background-color: #f5f5f5;
    // height: 1000px;
    // height: calc(100% + 1px);
    // overflow-y: auto;
    // overflow-x: hidden;
    // -webkit-overflow-scrolling: touch;
  }
}
.slide-right-enter,
.slide-right-leave-active {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.slide-right-enter-active,
.slide-right-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.filter-item ::v-deep {
  margin-bottom: 8px;
  background: #fff;
  .filter-tit {
    padding: 12px 12px 6px 12px;
    font-size: 14px;
    line-height: 24px;
    color: #999;
  }
  .cube-input {
    margin: 0 16px;
  }
  .cube-input-field {
    padding: 16px 0;
  }
  .cube-input::placeholder {
    color: #d6d6d6;
  }
  .cube-input:after {
    width: 0;
    border: none;
  }
}

/* .cube-form {
  padding-bottom: 50px;
  border-bottom: 1px solid #ccc;
  .code {
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    .cube-input,
    .cube-input_active {
      background-color: #f5f5f5;
    }
    .cube-input,
    .cube-input_active:after {
      border: 0;
      border-color: transparent;
    }
  }
} */
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
  padding: 8px;
  background-color: #fff;
  .cube-form-group-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .cube-btn {
    width: 176px;
    height: 46px;
    line-height: 46px;
    padding: 0 !important;
    border-radius: 4px;
  }
  .reset-btn {
    background: #fff;
    border: 1px solid #dbdbdb;
    color: #333;
  }
}
</style>
